(() => {
  'use strict';

  const initCatalog = (root) => {
    if (!root || root.dataset.bnDigitalCatalogMounted === 'true') return;
    root.dataset.bnDigitalCatalogMounted = 'true';

    const filters = Array.from(root.querySelectorAll('[data-bn-digital-filter]'));
    const items = Array.from(root.querySelectorAll('[data-bn-digital-item]'));
    const empty = root.querySelector('[data-bn-digital-empty]');

    if (!filters.length || !items.length) return;

    const applyFilter = (value) => {
      let visibleCount = 0;
      items.forEach((item) => {
        const level = item.dataset.bnDigitalLevel || 'all';
        const status = item.dataset.bnDigitalStatus || 'disponible';
        const matches = value === 'all' || level === value || status === value;
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount > 0;
      filters.forEach((button) => button.setAttribute('aria-pressed', button.dataset.bnDigitalFilter === value ? 'true' : 'false'));
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.bnDigitalFilter || 'all'));
    });
  };

  const init = () => {
    document.querySelectorAll('[data-bn-digital-catalog]').forEach(initCatalog);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
